"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromMarkdown = exports.fromMdast = void 0;
const toHast_1 = require("very-small-parser/lib/markdown/block/toHast");
const block_1 = require("very-small-parser/lib/markdown/block");
const import_html_1 = require("./import-html");
const fromMdast = (mdast, registry) => {
    const hast = (0, toHast_1.toHast)(mdast);
    const node = (0, import_html_1.fromHast)(hast, registry);
    return node;
};
exports.fromMdast = fromMdast;
const fromMarkdown = (markdown, registry) => {
    const mdast = block_1.block.parsef(markdown);
    return (0, exports.fromMdast)(mdast, registry);
};
exports.fromMarkdown = fromMarkdown;
